import { render } from "./MediaCard.vue?vue&type=template&id=64eb1773&ts=true"
import script from "./MediaCard.vue?vue&type=script&lang=ts"
export * from "./MediaCard.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src329832614/src/web-ext-giantstep/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__